import {useMutation, useQueryClient} from "@tanstack/react-query";
import axios from "axios";
import config from "../../../../../config";
import useAuth from "../../../../../utils/auth";
import {notifications} from "@mantine/notifications";
import {Photo, Video} from "../../hooks/useGalleryPhotos";

interface MoveVars {
  sourceId: number | null
  targetId: number
  photos: number[]
  videos: number[]
}

// Moves the selected photos/videos into the target gallery, then removes them from
// the source gallery cache and refreshes the target + gallery lists.
const useMovePhotos = () => {
  const auth = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (vars: MoveVars) =>
      axios.post(
        `${config.apiURL}/api/galleries/${vars.targetId}/move`,
        {photos: vars.photos, videos: vars.videos},
        {headers: {'Authorization': `Bearer ${auth.apiKey}`}}
      ),
    onSuccess: (_, vars) => {
      const data: any = queryClient.getQueryData(['gallery', vars.sourceId])
      if (data) {
        const copy = JSON.parse(JSON.stringify(data))
        const movedPhotos = new Set(vars.photos)
        const movedVideos = new Set(vars.videos)
        copy.photos = (copy.photos ?? []).filter((p: Photo) => !movedPhotos.has(p.id))
        copy.videos = (copy.videos ?? []).filter((v: Video) => !movedVideos.has(v.id))
        queryClient.setQueryData(['gallery', vars.sourceId], copy)
      }

      queryClient.invalidateQueries({queryKey: ['gallery', vars.targetId]})
      queryClient.invalidateQueries({queryKey: ['galleries']})

      notifications.show({title: 'Fotky přesunuty', message: ''})
    }
  })
}

export default useMovePhotos
